import React from 'react'
import withStyles from 'isomorphic-style-loader/withStyles'
import * as styles from './_NotFound.scss'

class NotFound extends React.Component {

  render () {
    return (
      <div className={styles['not-found-container']}>
        <h1>Sorry, we are unable to find the page you are looking for.</h1>
        <div className={styles['links']}>
          <ul>
                    Alternatively, here are some popular pages:
                    <li>
                      <a href='https://www.allangray.co.za/what-we-offer/unit-trust-investment/'>Start a basic investment</a>
                    </li>
            <li>
              <a href='https://www.allangray.co.za/what-we-offer/retirement/'>Save for your retirement</a>
            </li>
            <li>
              <a href='https://www.allangray.co.za/latest-insights/'>Latest insights</a>
            </li>
            <li>
              <a href='https://www.allangray.co.za/what-we-offer/unit-trusts/'>Unit trusts, prices &amp; factsheets</a>
            </li>
          </ul>
        </div>
      </div>
    )
  }
}

export default (NotFound)
